import { css } from "@linaria/core";
import { colors, fonts } from "@ui/Theme";

export const ErrorDetails = css`
  margin-top: 16px;
  color: ${colors.oxygen400};
  font: ${fonts.body2};
`;
